import script from "./DownloadDashboardDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadDashboardDialog.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadDashboardDialog.vue?vue&type=style&index=0&id=0a8bf9ff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a8bf9ff"]])

export default __exports__